import React from "react";
import PropTypes from "prop-types";
import Modal from "react-bootstrap/Modal";

const PnLRefreshModal = ({ show, openMonths, refreshing, onCancel, onConfirm }) => (
  <Modal show={show} onHide={onCancel} centered backdrop="static">
    <Modal.Header closeButton={!refreshing}>
      <Modal.Title as="h2" className="h5">Refresh report</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <p>Final months stay as they are. These open rows will be recalculated and saved to the snapshot:</p>
      <ul className="pnl-refresh-list">
        {openMonths.length === 0 && <li>Nothing to refresh. All months in this range are final.</li>}
        {openMonths.map((month) => (
          <li key={month.key}>
            <strong>{month.label}</strong>: {month.categories.join(", ")}
          </li>
        ))}
      </ul>
    </Modal.Body>
    <Modal.Footer>
      <button type="button" className="btn cus-primary-transparent-btn" onClick={onCancel} disabled={refreshing}>
        Cancel
      </button>
      <button
        type="button"
        className="btn cus-seconday-bg-btn"
        onClick={onConfirm}
        disabled={refreshing || openMonths.length === 0}
      >
        {refreshing ? "Refreshing..." : "Refresh now"}
      </button>
    </Modal.Footer>
  </Modal>
);

PnLRefreshModal.propTypes = {
  show: PropTypes.bool.isRequired,
  openMonths: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      categories: PropTypes.arrayOf(PropTypes.string).isRequired,
    })
  ).isRequired,
  refreshing: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default PnLRefreshModal;
